import React, { useState, useEffect } from 'react'
import { CButton, CRow, CCol, CContainer } from '@coreui/react-pro'
import LogoWhite from '../../assets/brand/logo-negative.svg'
import LogoBlack from '../../assets/brand/landing-logo.svg'
import { AiOutlineMenu } from 'react-icons/ai'
import { AiOutlineClose } from 'react-icons/ai'
import { HashLink as Link } from 'react-router-hash-link'
import PropTypes from 'prop-types'

const Nav = ({ isTextWhite }) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isSticky, setSticky] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        setSticky(true)
      } else {
        setSticky(false)
      }
    })
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [])

  return (
    <>
      <div className={`landing-nav ${isSticky ? 'bg-white shadow-lg' : ''}`} id="top">
        <CContainer
          className="d-flex align-items-center justify-content-between"
          style={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
          }}
        >
          <CRow>
            <CCol md="2" className="pt-4 pb-4">
              <Link to="/">
                <img
                  src={isTextWhite && !isSticky ? LogoWhite : LogoBlack}
                  alt="logo"
                  className="logo-size"
                />
              </Link>
            </CCol>
            <CCol
              md="10"
              className={isMobile ? 'mb-nav-links' : 'nav-links'}
              onClick={() => setIsMobile(false)}
            >
              <nav>
                <ul className="d-flex">
                  <li>
                    <Link
                      to="/#about-us"
                      className={`mx-3 text-decoration-none fs-5 ${
                        isTextWhite && !isSticky ? 'text-white' : 'text-black'
                      }`}
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#courses"
                      className={`mx-3 text-decoration-none fs-5 ${
                        isTextWhite && !isSticky ? 'text-white' : 'text-black'
                      }`}
                    >
                      Courses
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/#partners"
                      className={`mx-3 text-decoration-none fs-5 ${
                        isTextWhite && !isSticky ? 'text-white' : 'text-black'
                      }`}
                    >
                      Partners
                    </Link>
                  </li>
                  <li>
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href="https://academyblog.outsourceglobal.com/"
                      className={`mx-3 text-decoration-none fs-5 ${
                        isTextWhite && !isSticky ? 'text-white' : 'text-black'
                      }`}
                    >
                      Blog
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="login">
                {/* <Link to="/login">
                  <CButton className="normal-btn px-4">Login</CButton>
                </Link> */}
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfMCHmsvAtezWZp9S1tva5CgCuuBqCbt4uKxdNFYYMUwuv_kQ/viewform"
                  rel="noreferrer"
                  target="_blank"
                  className="mx-3 text-decoration-none"
                >
                  <CButton className="normal-btn px-4 py-2 w-100 text-white">Apply Now</CButton>
                </a>
              </div>
            </CCol>
          </CRow>
          <div className="mb-icon" onClick={() => setIsMobile(!isMobile)}>
            {isMobile ? <AiOutlineClose /> : <AiOutlineMenu />}
          </div>
        </CContainer>
      </div>
    </>
  )
}

Nav.propTypes = {
  isTextWhite: PropTypes.bool.isRequired,
}

export default Nav
